const routes = [
    {
        path: '/agency/stmn-agency-rqt',
        name: 'AgencyStmnAgencyRqt',
        meta: {
            layout: 'blank'
        },
        component: () => import(/* webpackChunkName: "main" */ '@/views/agency/stmn-agency-rqt.vue'),
    },
]

export default routes;
